import { m } from 'framer-motion';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';

import { bgGradient } from 'src/theme/css';

import { varFade, MotionContainer } from 'src/components/animate';

// ----------------------------------------------------------------------

const CONTACTS = [
  {
    heading: 'Project Collaboration',
    address: 'Have a Project or want to Collaborate?',
    phoneNumber: 'satyendrasr.cereer@gmail.com',
  },
  {
    heading: 'Permanent Address',
    address: 'Banda Uttar Pradesh ,210001',
    phoneNumber: '+91 78 6935 1845',
  },
  {
    heading: 'Temporary Residence',
    address: 'NGR Layout Bangalore,560068',
    phoneNumber: '+91 78 6935 1845',
  },
];

// ----------------------------------------------------------------------

export default function ContactHero() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        ...bgGradient({
          color: alpha(theme.palette.grey[900], 0.8),
          imgUrl: '/assets/images/myphoto/satyendra_singh_2.jpeg',
        }),
        py: { xs: 12, md: 0 },
        minHeight: { xs: 400, md: 460 },
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container component={MotionContainer}>
        <Box
          sx={{
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <TextAnimate
            text="Where"
            sx={{ color: 'primary.main', typography: { xs: 'h4', md: 'h2' } }}
            variants={varFade().inRight}
          />
          <br />

          <Stack
            spacing={1.5}
            direction="row"
            sx={{ color: 'common.white', justifyContent: { xs: 'center', md: 'flex-start' } }}
          >
            <TextAnimate text="To" />
            <TextAnimate text="Find" />
            <TextAnimate text="Me?" />
          </Stack>

          <Stack
            spacing={5}
            direction={{ xs: 'column', md: 'row' }}
            sx={{ mt: 5, color: 'common.white' }}
          >
            {CONTACTS.map((contact, index) => (
              <Stack key={index} sx={{ maxWidth: 300, textAlign: { xs: 'center', md: 'left' } }}>
                <m.div variants={varFade().inUp}>
                  <Typography variant="h6" gutterBottom>
                    {contact.heading}
                  </Typography>
                </m.div>

                <m.div variants={varFade().inRight}>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    {contact.address}
                    <br /> {contact.phoneNumber}
                  </Typography>
                </m.div>
              </Stack>
            ))}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}

// ----------------------------------------------------------------------

function TextAnimate({ text, variants, sx, ...other }) {
  return (
    <Box
      component={m.div}
      sx={{
        typography: 'h1',
        overflow: 'hidden',
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
      {text.split('').map((letter, index) => (
        <m.span key={index} variants={variants || varFade().inUp}>
          {letter}
        </m.span>
      ))}
    </Box>
  );
}

TextAnimate.propTypes = {
  sx: PropTypes.object,
  text: PropTypes.string,
  variants: PropTypes.object,
};
